import { Component } from "react";

class ImageBlock extends Component {
	render() {
		const { blockProps } = this.props;
		const { entity } = blockProps;
		const { val, styleString, hAlign, vAlign } = entity.getData();
		return (
			<span
				style={{
					display: "flex",
					justifyContent: hAlign || "center",
					alignItems: vAlign || "center",
				}}
			>
				<span style={styleString} dangerouslySetInnerHTML={{ __html: val }} />
			</span>
		);
	}
}

export default ImageBlock;
